// 验证手机号
export function validatePhone(phone) {
	const reg = /^1[3-9]\d{9}$/
	return reg.test(phone)
}

// 验证密码（6-18位字母/数字）
export function validatePassword(password) {
	const reg = /^[a-zA-Z0-9]{6,18}$/
	return reg.test(password)
}

// 验证验证码（6位数字）
export function validateCode(code) {
	const reg = /^\d{6}$/
	return reg.test(code)
}